import * as React from 'react';

export interface IconProps {
    name: string;
    id?: string;
    className?: string;
    title?: string;
    onClick?: () => void;
}

export function Icon(props: IconProps) {
    let className = props.className !== undefined ? props.className : '';
    className = className + ' embla-icon';

    const title = props.title ? <title>{props.title}</title> : null;

    return (
        <svg onClick={props.onClick} id={props.id} className={className} aria-hidden='true' version='1.1' xmlns='http://www.w3.org/2000/svg'>
            {title}
            <use xlinkHref={process.env.PUBLIC_URL + '/icons/sprite.symbol.svg#' + props.name} />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/Icon.tsx